import lamp from "../../../image/aboutUs/light-lamp.png";
import hat from "../../../image/aboutUs/hat.png";
import computer from "../../../image/aboutUs/computer.png";

export const WhyAzeto = [
  {
    id: 1,
    heading: "خلاق شو",
    body: "آزتو یک زمین بازی برای رشد و شکوفایی خلاقیت است.آزمایش‌های جدید طراحی کنید و نتایج طراحی خور را ببینید. خلاقیت یک عنصر جدانشدنی از آزتو است.",
    img: lamp,
    background: "#5767BF",
  },
  {
    id: 2,
    heading: "تحقق آرزو‌ها",
    body: "با یادگیری هدفمند و عمیق مطالب علمی و درسی، طرز تفکر و نحوه نگرش خود را تغییر داده و اهداف و آرزوهای خود را تیک بزنید.",
    img: hat,
    background: "#ffac30",
  },
  {
    id:3,
    heading: "هوشمند و آنلاین",
    body: "همیشه و همه جا و با هر دستگاهی با آزتو همراه باش و تجربیات لذت‌بخشی داشته باشید. امتیاز جمع کنید، با دوستان خود رقابت کنید و سرگرم شوید!",
    img: computer,
    background: "#3ea5db",
  },
];
